import store from "../storeWire";
import {
    alternative_product_by_variant_number_list,
    product_category_list, product_document_list,
    product_images_list,
    alternative_products_count,
    product_documents_count,
    check_if_design_available,
    get_all_design_data,
    get_product_category_external_search,
    clearAlternativeProductData,
    check_designs_exist
} from "../store/slice/model/ProductDetail";
import { useSelector } from "react-redux";
import { set_to_master_data_only_products_list } from "../store/slice/model/ProductListing";
import ProductRepository from "src/repository/ProductRepository";
import { isEqual } from "underscore";

export function useProductStore() {
    const list = useSelector((state) => state.entities.ProductListingAPICall.data, isEqual)
    const category_filter_applied_status = useSelector((state) => state.entities.model_ProductListing.category_filter_applied_status)
    const append_facade_options_status = useSelector((state) => state.entities.model_ProductListing.append_facade_options_status)
    const product_document_data = useSelector((state) => state.entities.model_ProductDetail.documentData)
    const product_document_count = useSelector((state) => state.entities.model_ProductDetail.documentCount)
    const product_images_data = useSelector((state) => state.entities.model_ProductDetail.imagesData)
    const alternative_product_data = useSelector((state) => state.entities.model_ProductDetail.alternativeProductData)
    const alternative_product_count = useSelector((state) => state.entities.model_ProductDetail.alternativeProductCount)
    const productDetail = useSelector((state) => state.entities.model_ProductDetail.setProductDetail.data)
    const designHubData = useSelector((state) => state.entities.model_ProductDetail.designHubData.data)
    let data = {
        productDetail,
        category_filter_applied_status,
        append_facade_options_status,
        product_document_data,
        product_document_count,
        alternative_product_data,
        alternative_product_count,
        product_images_data,
        list,
        designHubData
    };

    let fetch = {
        fetch_product_category_list: async () => {
            return await store.dispatch(product_category_list())
        },

        check_if_design_available: async (params) => {
            return await store.dispatch(check_if_design_available(params))
        },

        check_designs_exist: async (params) => {
            return await store.dispatch(check_designs_exist(params))
        },

        get_product_category_external_search: async (params) => {
            return await store.dispatch(get_product_category_external_search(params))
        },
        get_all_design_data: async (params) => {
            return await store.dispatch(get_all_design_data(params))
        },

        fetch_product_document_list: async (params) => {
            return await store.dispatch(product_document_list(params))
        },

        fetch_product_document_count: async (params) => {
            return await store.dispatch(product_documents_count(params))
        },

        fetch_product_images_list: async (params) => {
            return await store.dispatch(product_images_list(params))
        },

        fetch_alternative_product_by_variant_number_list: async (params) => {
            let p = await store.dispatch(alternative_product_by_variant_number_list(params))
            await store.dispatch(await set_to_master_data_only_products_list(p.payload));
            return p.payload;
        },
        fetch_alternative_product_count: async (params) => {
            return await store.dispatch(alternative_products_count(params))
        },
        fetch_is_manual_cpn: (productDetail, selectedCpn) => {
            return new ProductRepository().isCpnIsManualCPN(productDetail, selectedCpn);
        },
        get_universal_product_search_list: async (params) => {
            return await new ProductRepository().getUniversalProductSearchList(params);
        },
        get_universal_category_manufacturers_search_list: async (params) => {
            return await new ProductRepository().getUniversalCategoryManufacturersSearchList(params);
        },
       
    };
    let set = {
        clear_alternative_product_data: () => {
            return store.dispatch(clearAlternativeProductData())
        }
    };
    let operations = {
        optionsAvailable: () => {
            if (!(list !== undefined && list['@search.facets'] !== undefined)) {
                return;
            }

            function checkOptionsAvailableFromAPI(facetName) {
                return list['@search.facets'] !== undefined &&
                    list['@search.facets'][facetName] !== undefined;
            }

            let LinkedWithSystem = {};
            if (Object.entries(list['@search.facets']).length > 0) {
                Object.entries(list['@search.facets']).map((v, i) => {
                    LinkedWithSystem[v[1].slug] = {
                        slug: v[1].slug,
                        main_label: v[1].main_label
                    };
                });
            }
            Object.entries(LinkedWithSystem).map((v, i) => {
                if (v[1].slug === 'FamilyName') {
                    delete LinkedWithSystem[v[1].slug];
                }
                if (v[1].slug === 'Categories') {
                    delete LinkedWithSystem[v[1].slug];
                }
                if (v[1].slug === 'ManufacturerName') {
                    delete LinkedWithSystem[v[1].slug];
                }
                if (v[1].main_label === 'Attributes') {
                    delete LinkedWithSystem[v[1].slug];
                }
                if (v[1].slug === 'FlagFacets') {
                    delete LinkedWithSystem[v[1].slug];
                }
                if (v[1].slug === 'flagFacets') {
                    delete LinkedWithSystem[v[1].slug];
                }
                if (!checkOptionsAvailableFromAPI(v[1].slug)) {
                    delete LinkedWithSystem[v[1].slug];
                }
            });

            return LinkedWithSystem;
        }
    };

    return [data, fetch, set, operations]
}